import EntityAutocompleteWidget from "@/framework/KioForm/widgets/EntityAutocompleteWidget";
import { useStore } from "@/Store";
import Api from "@/services/Api";
import { useParams } from "react-router-dom";
import { useMessenger } from "@/framework/Messenger/Messenger";
import type { FieldProps } from "@rjsf/utils";
import type { FC } from "react";

interface RemoteClientSelectorFieldProps extends Partial<FieldProps> {}

const RemoteClientSelectorField: FC<RemoteClientSelectorFieldProps> = ({ formContext }) => {
  const store = useStore();
  const selectedClientId = formContext.remoteClientId;
  const isSuperAdmin = store.state.user?.is_admin;
  const currentOwnerMuseumsApiId = store.state.cmsContextInstance?.owner_museums_api_id;
  const currentDocumentId = Number(useParams<{ documentId: string }>().documentId);
  const msg = useMessenger();

  const onRemoteClientChange = async (documentId: number, remoteClientId: number) => {
    Api.linkRemoteClientIdToDocument(documentId, remoteClientId)
      .fetch()
      .then((response) => {
        const [_res, err, _source] = response;
        if (err) {
          throw err;
        }
        if (remoteClientId) {
          console.info("Successfully linked remote client to document");
          msg.success("Successfully linked remote client to document", 3000);
        } else {
          console.info("Successfully unlinked remote client from document");
          msg.success("Successfully unlinked remote client from document", 3000);
        }
      })
      .catch((err) => {
        if (err?.code) {
          msg.error(`code: ${err.code}, message: ${err.message}`);
        } else {
          msg.error(err);
        }
      });
  };

  return (
    <div>
      {isSuperAdmin && (
        <EntityAutocompleteWidget
          id={"test"}
          options={{ type: "PCSClient", valueField: "id", displayField: "name" }}
          uiSchema={{
            "ui:title": "Remote ClientId",
            "ui:description": "Select a remote client to connect to. Only available for admin users.",
          }}
          schema={{}}
          formContext={{ variant: "filled" }}
          onChange={async (selectedClientId) => {
            await onRemoteClientChange(currentDocumentId, selectedClientId);
          }}
          limitToMuseumsApiId={currentOwnerMuseumsApiId}
          value={selectedClientId}
        />
      )}
    </div>
  );
};
export default RemoteClientSelectorField;
